import {AnalyticsBrowser} from '@segment/analytics-next';
import {ANALYTICS_EVENTS} from './constants';
import {parseQuery} from '../utils';

const ANALYTICS_PREFIX = 'tr_';

class AnalyticsService {
    private analytics: AnalyticsBrowser = new AnalyticsBrowser();

    page = (...args) => this.analytics.page(...args);

    load = (writeKey: string) => this.analytics.load({writeKey});

    identify = (...args) => this.analytics.identify(...args);

    reset = (...args) => this.analytics.reset();

    track = (eventName, properties = {}, options = {}) => {
        const additionalProperties = Object
            .entries(parseQuery(window.location.search))
            .reduce((acc, [key, value]) => {
                return key.startsWith(ANALYTICS_PREFIX) ? {...acc, [key]: value} : acc;
            }, {});

        this.analytics.track(eventName, {...properties, ...additionalProperties}, options);
    };
}

export default new AnalyticsService();
export {ANALYTICS_EVENTS, ANALYTICS_PREFIX};
